<div class="billing-wrapper pb-3">
  <form class="billing-form" [formGroup]="billingForm"
    style="display: flex; flex-direction: row; gap: 30px; width: 100%;" (ngSubmit)="goToConfirmation()">

    <!-- Left Section: Billing Details -->
    <div class="billing-left">
      <h2 class="billing-title">Billing Details</h2>

      <!-- Row 1 -->
      <div class="row">
        <div class="col-6">
          <div class="input-container">
            <label for="name" class="label">Billing Name*</label>
            <div
              [ngClass]="{ 'invalid-input': billingForm.get('billingName')?.invalid && billingForm.get('billingName')?.touched }">
              <input class="input-text input" type="text" id="billingName" placeholder="Name" appRestrictSpecialChars appRestrictNumbers [appMaxLength]="50"
                formControlName="billingName" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-container">
            <label class="label">Phone Number *</label>
            <div
              [ngClass]="{ 'invalid-input': billingForm.get('phoneNumber')?.invalid && billingForm.get('phoneNumber')?.touched }">
              <app-phone-country-input formControlName="phoneNumber"></app-phone-country-input>
            </div>
          </div>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="row">
        <div class="col-6">
          <div class="input-container">
            <label class="label">Email ID*</label>
            <div
              [ngClass]="{ 'invalid-input': billingForm.get('email')?.invalid && billingForm.get('email')?.touched }">
              <input class="input input-text" placeholder="Email Address" type="email" formControlName="email" />
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="input-container">
            <label class="label">GSTIN <span *ngIf="billingForm.get('isRegisteredForGSTIN')?.value">*</span></label>
            <div
              [ngClass]="{ 'invalid-input': billingForm.get('gstin')?.invalid && billingForm.get('gstin')?.touched }">
              <input class="input-text input" type="text" placeholder="GSTIN" formControlName="gstin" appRestrictSpecialChars [appMaxLength]="15" />
            </div>
          </div>
        </div>
      </div>

      <!-- Row 3 -->
      <div class="row">
        <div class="col-12">
          <app-address-fields formControlName="address"></app-address-fields>
        </div>
      </div>

      <!-- GSTIN Registered -->
      <div class="gstin-line"
        [ngClass]="{ 'invalid-input': billingForm.get('isRegisteredForGSTIN')?.invalid && billingForm.get('isRegisteredForGSTIN')?.touched }">
        <label class="gstin-label">Are you registered for GSTIN</label>
        <label><input type="radio" formControlName="isRegisteredForGSTIN" [value]="true" /> Yes</label>
        <label><input type="radio" formControlName="isRegisteredForGSTIN" [value]="false" /> No</label>
      </div>

      <div>
        <p class="mb-0 mt-2" style="font-size: 14px;"><b>Note: </b>Your card details are not stored anywhere</p>
      </div>
    </div>

    <!-- Right Section: Amount Summary -->
    <div class="billing-right">
      <div class="summary-card">
        <h3 class="summary-title">Amount Summary</h3>
        <div class="summary-row">
          <span>Plan Selected</span><strong>{{ billingForm.get('planSelected')?.value }}</strong>
        </div>
        <div class="summary-row">
          <span>Number of Users</span><strong>{{ billingForm.get('totalLicense')?.value === -1 ? "Unlimited":
            billingForm.get('totalLicense')?.value}}</strong>
        </div>
        <div class="summary-row">
          <span>Sub Amount</span><strong> {{ billingForm.get('amount')?.value | currency:'INR':'symbol' }}/-</strong>
        </div>
        <div class="summary-row">
          <span>CGST 9%</span><strong> {{ calculateTax(billingForm.get('amount')?.value, 9) | currency:'INR':'symbol' }}/-</strong>
        </div>
        <div class="summary-row">
          <span>SGST 9%</span><strong> {{ calculateTax(billingForm.get('amount')?.value, 9) | currency:'INR':'symbol' }}/-</strong>
        </div>
        <div class="summary-total">
          <span>Total Amount</span><strong class="highlight"> {{ billingForm.get('totalAmount')?.value |
            currency:'INR':'symbol'
            }}/-</strong>
        </div>

        <button type="submit" class="proceed-btn">Proceed</button>
        <p class="privacy-text">
          By proceeding, you agree to our <span class="text-primary" style="cursor: pointer;"
            (click)="privacyAndPolicy()">Privacy Policy</span>
        </p>
      </div>
    </div>

  </form>

</div>